import { getItemFromSessionStorage } from 'mini-session-storage';

export const SESSION_DATA_SESSION_STORAGE_KEY = 'session';

export function getSessionDataFromSessionStorage() {
    return getItemFromSessionStorage(SESSION_DATA_SESSION_STORAGE_KEY);
}
